export enum FILE_EXTENSION {
  CSV = 'csv',
  DOCX = 'docx',
  DOC = 'doc',
  PDF = 'pdf',
  XLSX = 'xlsx',
  XLS = 'xls',
  DUMP = 'dump',
  ZIP = 'zip',
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  JSON = 'json',
  TXT = 'txt',
  HEIC = 'heic',
  HEIF = 'heif',
  MP4 = 'mp4',
  MOV = 'mov',
  WEBM = 'webm',
  MKV = 'mkv',
  EML = 'eml',
  MSG = 'msg',
}

export const supportedImageExtensions = [
  FILE_EXTENSION.PNG,
  FILE_EXTENSION.JPEG,
  FILE_EXTENSION.JPG
];

export const supportedVideoExtensions = [
  FILE_EXTENSION.MP4,
  FILE_EXTENSION.MOV,
  FILE_EXTENSION.WEBM,
  FILE_EXTENSION.MKV,
];

export const EXPORT_LIMIT = 10000;